export default __webpack_public_path__ + "static/media/SAPC-Logo-red.2ca569cc.png";